import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { MaskLineOnView } from "@/components/site/ContactHeadline";
import { Reveal } from "@/components/site/anim";
import ContactForm from "@/components/site/ContactForm";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      {/* Headline */}
      <section className="relative bg-base pt-36 md:pt-44 pb-10 px-6 md:px-10 overflow-hidden">
        <div className="mx-auto max-w-[1600px]">
          <Reveal as="p" className="font-mono text-xs uppercase tracking-[0.25em] text-accent mb-6">
            Contact
          </Reveal>
          <h1 className="font-heading font-black uppercase tracking-tighter leading-[0.85] text-[16vw] md:text-[12vw] lg:text-[10vw] text-glow">
            <MaskLineOnView>Let's</MaskLineOnView>
            <MaskLineOnView delay={0.1}>Talk<span className="text-accent">.</span></MaskLineOnView>
          </h1>
          <Reveal delay={0.2} as="p" className="mt-6 max-w-xl text-[#A1A1AA] text-lg md:text-xl leading-relaxed">
            Tell us what's slowing you down and we'll tell you how we'd fix it —
            no pitch decks, just straight answers.
          </Reveal>
        </div>
      </section>

      {/* Form + info */}
      <section data-testid="contact-body" className="bg-base pb-24 md:pb-32 px-6 md:px-10">
        <div className="mx-auto max-w-[1600px] grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7">
            <ContactForm />
          </div>

          <div className="lg:col-span-5 lg:pl-4">
            <div className="space-y-8">
              <InfoRow icon={Mail} label="Email" testid="contact-email">
                <a href="mailto:contact@quadrimtech.com" className="link-underline hover:text-white transition-colors duration-300">
                  contact@quadrimtech.com
                </a>
              </InfoRow>
              <InfoRow icon={Phone} label="Phone" testid="contact-phone">
                <a href="tel:+19493138186" className="link-underline hover:text-white transition-colors duration-300">
                  +1 949 313 8186
                </a>
              </InfoRow>
              <InfoRow icon={MapPin} label="Studio">
                1968 S Coast Hwy #1363<br />
                Laguna Beach, CA<br />
                United States
              </InfoRow>
              <InfoRow icon={Clock} label="Hours">
                Mon – Fri, 8am – 6pm PT<br />
                Support desk 24 / 7
              </InfoRow>
            </div>

            <div className="mt-10 overflow-hidden rounded-2xl border border-white/10">
              <iframe
                title="Quadrim Tech location"
                data-testid="contact-map"
                src="https://www.google.com/maps?q=1968%20S%20Coast%20Hwy%2C%20Laguna%20Beach%2C%20CA&output=embed"
                className="w-full h-64 grayscale contrast-125 opacity-90"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function InfoRow({ icon: Icon, label, children, testid }) {
  return (
    <div className="flex items-start gap-4" data-testid={testid}>
      <span className="grid h-11 w-11 place-items-center rounded-full border border-white/10 bg-surface shrink-0">
        <Icon className="h-5 w-5 text-accent" />
      </span>
      <div>
        <div className="font-mono text-[11px] uppercase tracking-[0.15em] text-[#71717A] mb-1">{label}</div>
        <div className="font-heading text-lg md:text-xl font-medium tracking-tight text-white leading-snug">
          {children}
        </div>
      </div>
    </div>
  );
}
